const getUserRole = (state) => {
  return state.user.role
}

const isPartner = (state) => {
  return state.user.role === 'partner'
}

const isVendor = (state) => {
  return state.user.role === 'vendor'
}

const showOnboardBanner = (state) => {
  return (state.user.role === 'partner' && !state.partner.has_completed_onboarding)
}

const getTableColumns = (state) => {
  return state.user.view_settings
}

export default {
  getUserRole,
  isPartner,
  isVendor,
  showOnboardBanner,
  getTableColumns,
}
